import type { BoxListItem, BoxProductItem } from "../../../api/WarehouseApi";

export type DestroyConfirmTarget =
  | { kind: "currentBox"; boxName: string }
  | { kind: "childBox"; boxId: string; boxName: string }
  | { kind: "product"; productId: string; productName: string };

export function createCurrentBoxDestroyTarget(
  boxName: string,
): DestroyConfirmTarget {
  return {
    kind: "currentBox",
    boxName,
  };
}

export function createChildBoxDestroyTarget(
  item: BoxListItem,
): DestroyConfirmTarget {
  return {
    kind: "childBox",
    boxId: item.id,
    boxName: item.name,
  };
}

export function createProductDestroyTarget(
  item: BoxProductItem,
): DestroyConfirmTarget {
  return {
    kind: "product",
    productId: item.id,
    productName: item.name,
  };
}

export function getDestroyConfirmTitle(
  target: DestroyConfirmTarget | null,
): string {
  if (!target) {
    return "";
  }

  if (target.kind === "product") {
    return `Уничтожить продукт "${target.productName}"?`;
  }

  return `Уничтожить коробку "${target.boxName}"?`;
}

export function getDestroyConfirmDescription(input: {
  target: DestroyConfirmTarget | null;
  childProductsCount: number;
  childBoxesCount: number;
}): string {
  const { target, childBoxesCount, childProductsCount } = input;
  if (!target) {
    return "";
  }

  if (target.kind === "currentBox") {
    const details =
      childProductsCount > 0 || childBoxesCount > 0
        ? `\n\nВнутри сейчас: коробок ${childBoxesCount}, товаров ${childProductsCount}. Если коробка не пустая, сервер вернет ошибку и удаление не произойдет.`
        : "";
    return `Коробка будет перемещена в удаленные. Полное удаление доступно только администратору.${details}`;
  }

  if (target.kind === "childBox") {
    return "Вложенная коробка будет перемещена в удаленные. Полное удаление доступно только администратору.";
  }

  return "Товар будет перемещен в удаленные. Полное удаление доступно только администратору.";
}

export function resolveChildBoxDestroyTarget(input: {
  target: DestroyConfirmTarget;
  childBoxes: BoxListItem[];
}): BoxListItem | null {
  const target = input.target;
  if (target.kind !== "childBox") {
    return null;
  }

  return input.childBoxes.find((item) => item.id === target.boxId) ?? null;
}

export function resolveProductDestroyTarget(input: {
  target: DestroyConfirmTarget;
  childProducts: BoxProductItem[];
}): BoxProductItem | null {
  const target = input.target;
  if (target.kind !== "product") {
    return null;
  }

  return (
    input.childProducts.find((item) => item.id === target.productId) ?? null
  );
}
